<template>
  <div class="course-helper-wrap" :class="{ 'course-helper-h5': isH5 }">
    <img
      @click="handleShowQrcode"
      class="kefu"
      src="../../../assets/images/course-helper/kefu.png"
      alt=""
    />
    <div @click="handleShowQrcode" class="tips">
      {{ guide || assistant.guide }}
    </div>
    <div
      v-if="!isH5"
      class="qrcode-wrap"
      :class="{ 'show-qrcode': showQrcode }"
    >
      <i @click="showQrcode = false" class="el-icon-close close" />
      <p class="title">{{ guide || assistant.guide }}</p>
      <img
        class="qrcode"
        :src="assistant.img_url + '?imageView2/0/w/400'"
        alt=""
      />
      <p class="type-tips" v-html="typeTips"></p>
      <div v-if="assistant.contact_way" class="copy-wrap">
        <p class="contact-number">{{ assistant.contact_way }}</p>
        <button class="copy-btn" @click="copyNumber">
          <img src="../../../assets/images/copy-icon.png" alt="" />
        </button>
      </div>
    </div>

    <el-dialog
      v-else
      custom-class="h5-course-helper-dialog"
      :visible.sync="dialogVisible"
      center
      :before-close="handleClose"
      append-to-body
    >
      <i @click="dialogVisible = false" class="el-icon-close close" />
      <p class="title">{{ guide || assistant.guide }}</p>
      <img
        class="qrcode"
        :src="assistant.img_url + '?imageView2/0/w/400'"
        alt=""
      />
      <p class="type-tips" v-html="typeTips"></p>
      <div v-if="assistant.contact_way" class="copy-wrap">
        <p class="contact-number">{{ assistant.contact_way }}</p>
        <button class="copy-btn" @click="copyNumber">
          <img src="../../../assets/images/copy-icon.png" alt="" />
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CONTACT_WAY_TYPE } from "@saas/components/src/utils/constants.js";
import { isHXApp, clipboard, isH5, isMobile } from "@saas/components/src";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
export default {
  props: {
    courseId: {
      type: String,
      default: "",
    },
    assistant: {
      type: Object,
      default: () => {},
    },
    guide: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      dialogVisible: false,
      showQrcode: false,
      number: "82464652699",
      isHXApp: isHXApp(),
      isMobile: isMobile(),
      contactType: CONTACT_WAY_TYPE,
      isH5: isH5(),
    };
  },
  computed: {
    typeTips() {
      let type = this.assistant.contact_way_type;
      if (type === this.contactType.NO_WAY) {
        return "";
      } else if (type === this.contactType.WX) {
        return `使用<span>微信</span>扫码，添加老师或进群。您也可手动添加<span>微信号</span>:`;
      } else {
        if (type === this.contactType.QQ) {
          return `使用<span>QQ</span>扫码，添加老师或进群。您也可手动添加<span>QQ号</span>:`;
        } else {
          return `使用<span>QQ</span>扫码，添加老师或进群。您也可手动添加<span>QQ群</span>:`;
        }
      }
    },
  },
  methods: {
    handleShowQrcode() {
      if (this.isHXApp) {
        jsToFlutter("wxpay", {
          miniProgramOrgId: "gh_f7e654a66b33",
          prePayTn: `pages/teacher-qrcode/index?courseId=${this.courseId}`,
          // miniProgramType: 0正式版，1开发版，2体验版
          // 非生产环境使用体验版
          miniProgramType: process.env.VUE_APP_ENV !== 'production' ? 2 : 0,
        });
      } else if (this.isH5) {
        this.dialogVisible = true;
      } else {
        this.showQrcode = true;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    copyNumber() {
      clipboard(this.assistant.contact_way, () => {
        this.$showToast("联系方式复制成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-helper-wrap {
  z-index: 9;
  position: relative;
  position: fixed;
  right: 80px;
  bottom: 100px;
  width: 32px;
  height: 32px;
  &:hover {
    .tips {
      opacity: 1;
      pointer-events: auto;
    }
  }
  .kefu {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .tips {
    // pointer-events: none;
    // transition: all 0.5s;
    // opacity: 0;
    cursor: pointer;
    opacity: 1;
    pointer-events: auto;
    position: absolute;
    bottom: 38px;
    left: 50%;
    transform: translateX(-50%);
    width: 22px;
    height: auto;
    padding: 10px 5px 12px;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    line-height: 13px;
    background-image: url("../../../assets/images/course-helper/bubble.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center bottom;
    line-break: anywhere;
    text-align: center;
    border-radius: 11px;
    // 防止被选中
    -webkit-touch-callout: none; /*系统默认菜单被禁用*/
    -webkit-user-select: none; /*webkit浏览器*/
    -khtml-user-select: none; /*早期浏览器*/
    -moz-user-select: none; /*火狐*/
    -ms-user-select: none; /*IE10*/
    user-select: none;
    -webkit-user-select: none;
  }

  // 在移动端中
  &.course-helper-h5 {
    right: 0.27rem;
    bottom: 5.3rem;
    width: 0.85rem;
    height: 0.85rem;
    .kefu {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .tips {
      opacity: 1;
      pointer-events: auto;
      bottom: 1rem;
      width: 0.59rem;
      padding: 0.27rem 0.13rem 0.32rem;
      font-size: 0.32rem;
      line-height: 0.35rem;
      border-radius: 0.29rem;
    }
  }
}

.qrcode-wrap {
  pointer-events: none;
  opacity: 0;
  position: absolute;
  bottom: 38px;
  right: 0;
  width: 300px;
  max-height: 512px;
  background: linear-gradient(42deg, #daffef 0%, #ffffff 100%);
  border-radius: 16px;
  padding: 24px 16px 0;
  transition: all 0.5s;
  padding-bottom: 20px;
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    content: "";
    width: 60px;
    height: 52px;
    background-image: url("../../../assets/images/logo-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  &.show-qrcode {
    opacity: 1;
    pointer-events: auto;
  }
  .close {
    position: absolute;
    top: 13px;
    right: 13px;
    font-size: 15px;
    font-weight: bold;
    color: #4e5969;
    padding: 3px;
    cursor: pointer;
    z-index: 1;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 24px;
    width: 260px;
    height: 54px;
    border-radius: 8px;
    background: rgba($color: #ffffff, $alpha: 0.6);
    margin: 0 auto 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .qrcode {
    width: 200px;
    max-height: 260px;
    margin: 0 auto 20px;
  }
  ::v-deep .type-tips {
    font-size: 15px;
    color: #0d1400;
    line-height: 24px;
    margin-bottom: 14px;
    span {
      font-weight: bold;
    }
  }
  .copy-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 260px;
    height: 54px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #00c89d;
    margin: 0 auto;
    padding: 0 8px 0 8px;
    font-weight: 500;
    font-size: 30px;
    color: #0d1400;
    line-height: 1;
    .copy-btn {
      width: 14px;
      height: 14px;
      margin-left: 8px;
    }
    .contact-number {
      flex: 1;
      width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-break: anywhere;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.h5-course-helper-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  width: 8rem !important;
  background: linear-gradient(42deg, #daffef 0%, #ffffff 100%) !important;
  border-radius: 0.43rem !important;
  margin-bottom: 0.77rem;
  padding: 0.64rem 0.43rem 0.64rem;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  .close {
    position: absolute;
    top: 0.35rem;
    right: 0.35rem;
    font-size: 0.4rem;
    font-weight: bold;
    color: #4e5969;
    padding: 0.08rem;
    cursor: pointer;
    z-index: 1;
  }
  .title {
    width: 6.93rem;
    height: 1.44rem;
    border-radius: 0.21rem;
    background: rgba($color: #ffffff, $alpha: 0.6);
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.64rem;
    margin: 0 auto 0.37rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .qrcode {
    width: 5.33rem;
    max-height: 6.929rem;
    margin: 0 auto 0.53rem;
  }
  .type-tips {
    font-size: 0.4rem;
    color: #0d1400;
    line-height: 0.64rem;
    margin-bottom: 0.37rem;
    span {
      font-weight: bold;
    }
  }
  .copy-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 6.93rem;
    height: 1.44rem;
    background: #ffffff;
    border-radius: 0.21rem;
    border: 0.03rem solid #00c89d;
    margin: 0 auto;
    padding: 0 0.21rem 0 0.21rem;
    font-weight: 500;
    font-size: 0.8rem;
    color: #0d1400;
    line-height: 1;
    .copy-btn {
      width: 0.37rem;
      height: 0.37rem;
      margin-left: 0.21rem;
    }
    .contact-number {
      flex: 1;
      width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-break: anywhere;
      text-align: center;
    }
  }
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    content: "";
    width: 1.57rem;
    height: 1.36rem;
    background-image: url("../../../assets/images/logo-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>
